import React, { FC } from 'react';
import ScrollArea from 'react-scrollbar';
import colors from '../../assets/colors';

interface IProps {
	children?: any;
	width: number;
}

const CustomScrollbar: FC<IProps> = ({ children, width }) => {
	return (
		<ScrollArea
			speed={0.4}
			smoothScrolling
			vertical={false}
			horizontalScrollbarStyle={{ height: 5, backgroundColor: colors.scrollbarColor }}
			horizontalContainerStyle={{ height: 5, backgroundColor: colors.white }}
			contentStyle={{ width }}
		>
			{children}
		</ScrollArea>
	);
};

export default CustomScrollbar;
